import { render } from "./NavForPublic.vue?vue&type=template&id=3f480601&ts=true"
import script from "./NavForPublic.vue?vue&type=script&lang=ts"
export * from "./NavForPublic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__